import { render, staticRenderFns } from "./AddAndEditForm.vue?vue&type=template&id=05d2d5ee"
import script from "./AddAndEditForm.vue?vue&type=script&lang=js"
export * from "./AddAndEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports